import React from 'react'
import { Backdrop, CircularProgress } from '@mui/material'
export default function LoadingBackdrop({ loading }) {
    return (
        <Backdrop style={{ color: '#FFF', zIndex: 2000 }} open={loading}>
            <CircularProgress color="inherit" disableShrink />
        </Backdrop>
    )
}